/** Énumération listant les différents types de rapport disponibles. */
export enum ERapportType {
	transmission = "transmission"
}